const API_KEY = 'qdm0Lp425vvcnE6CFXoTQLrJvQkjG1KHWACQsECb71Q'

export default API_KEY